export enum ActorMovementType {
  Instant = 0,
  Walk = 1,
  AutoWalk = 2,
  Explore = 3,
}
